import { Col, Form, Input } from 'antd'

import './styles.scss'
import { TFieldProps } from '..'
import { Rule } from 'antd/es/form'
import React from 'react'
import { FormState } from '@/state'

export default function VarcharFormField({ fieldInfo }: TFieldProps) {
  const isRequiredField = React.useMemo(() => {
    const formValues = FormState.currentFormValues.value ?? {}
    if (fieldInfo.name === 'housingProductiveActivityother') {
      return formValues.housingProductiveActivity === 'Otro'
    }

    return fieldInfo.required
  }, [FormState.currentFormValues.value, fieldInfo.required])

  const setFieldRules = React.useCallback((): Rule[] => {
    const rules: Rule[] = []

    if (isRequiredField) {
      rules.push({
        required: true,
        message: 'Este campo es obligatorio',
      })
    }

    return rules
  }, [isRequiredField])

  return (
    <Col
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}
      xxl={4}
      xl={6}
      md={8}
      sm={12}
      xs={24}
    >
      <Form.Item
        className={`varchar-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={isRequiredField}
        tooltip={fieldInfo.description}
        rules={setFieldRules()}
      >
        <Input size='small' />
      </Form.Item>
    </Col>
  )
}
